import { apiConfig } from '@/services/api-config';
import Vue from 'vue';

export default async function (resp: any) {
  return apiConfig
    .post('api/Agent/BillingAddress', resp, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(() => {
      Vue.swal('', 'Endereço atualizado com sucesso!', 'success');
    })
    .catch(() => {
      return false;
    });
}
